export enum V4ClassEnum {
  'area' = 'areas',
  'chemical' = 'chemicals',
  'fertilizer' = 'fertilizers',
  'cultivar' = 'cultivars',
  'tractor' = 'tractors',
  'implement' ='implements',
  'season' ='seasons'
}
